/**
 * Returns the saved report name from localStorage (step1 or report_name).
 * Used in CSRD and BRSR breadcrumb labels after the report is saved on the start page.
 */
export function getSavedReportName(fallback = "New Report") {
  try {
    const step1Raw = localStorage.getItem("step1");
    if (step1Raw) {
      const parsed = JSON.parse(step1Raw);
      if (parsed?.name) return parsed.name;
      if (parsed?.reportName) return parsed.reportName;
    }
  } catch (_) {
    /* ignore parse errors */
  }

  const fromStorage = localStorage.getItem("report_name");
  if (fromStorage && fromStorage !== "undefined" && fromStorage.trim()) {
    return fromStorage;
  }

  return fallback;
}
